<template>
  <div class="get_back">
    <div class="pc_forget">
      <div class="head_box">
        <p>找回密码</p>
        <span @click="setPop(false,false)"></span>
      </div>
      <div class="get_detail">
        <div class="menu_box">
          <span v-for="(item,index) in menu_list" :key="index" :class="{'menu_choose':menuIndex === index}">0{{index+1}} {{item}}</span>
        </div>
        <div class="type_box">
          <div class="get_way" v-show="menuIndex === 0">
            <div class="get_way_content">
              <div class="way_btn" @click="getPassword(1)">绑定手机号找回</div>
              <div class="way_btn" @click="getPassword(2)">注册手机号找回</div>
            </div>
          </div>
          <div class="information" v-show="menuIndex === 1">
            <div class="phone_way" v-if="wayIndex === 1">
              <div class="step_box">
                <div>
                  <span>账号：</span>
                  <input type='text' placeholder="请输入账号" v-model="account" @blur="judgeInfo(CheckType.Account)">
                  <em v-if="isAcc">账号应由6-20位的数字、字母组成或者手机号</em>
                  <em v-if="!isAcc&&(had_phone === 1||had_phone === 2)">{{had_phone_tip}}</em>
                  <i v-if="isAcc"></i>
                </div>
                <div>
                  <span>绑定手机号码：</span>
                  <input type='text' placeholder="请输入绑定的手机号" v-model="phone" @blur="judgeInfo(CheckType.Phone)">
                  <em v-if="isPhone">请输入正确的手机号码</em>
                  <em v-if="!isPhone&&is_match">该账号未绑定此手机号</em>
                  <i v-if="isPhone || is_match"></i>
                </div>
                <div>
                  <span>短信验证码：</span>
                  <input type='text' placeholder="请输入短信验证码" @blur="judgeInfo(CheckType.VerCode)" v-model="ver_code" class="code_box">
                  <span class="get_code" v-if='getting===false' @click="getPhoneCode()">获取验证码</span>
                  <span class="get_code count" v-if='getting'>重新发送（{{ get_time }}s）</span>
                  <i style="right: 265px" v-if="isCode"></i>
                  <em v-if="isCode&&ver_code===''">请输入验证码</em>
                  <em v-if="isCode&&ver_code!==''">请输入正确的验证码</em>
                </div>
                <div>
                  <span>新密码：</span>
                 <input type='password' @blur="judgeInfo(CheckType.Password)" @keyup="inputCheck()" placeholder="请输入新的6-20位登录密码" v-model="new_pwd">
                  <em v-if="isNew">密码应由6-20位的数字、字母或特殊符号组成</em>
                  <i v-if="isNew"></i>
                </div>
                <div v-if="resultTip">
                  <em>{{resultTip}}</em>
                </div>
                <div>
                  <span class="get_code" @click="comeTo(1)">下一步</span>
                  <span class="return_btn get_code" @click="comeTo(0)">返&nbsp;&nbsp;回</span>
                </div>
              </div>
            </div>
            <div class="phone_way" v-if="wayIndex === 2">
              <div class="step_box">
                <div>
                  <span>注册手机号码：</span>
                  <input type='text' placeholder="请输入手机号" v-model="phone" @blur="judgeInfo(CheckType.Phone)">
                  <em v-if="isPhone">请输入正确的手机号码</em>
                  <em v-if="phoneNotRegister">此手机号未注册</em>
                  <i v-if="isPhone || phoneNotRegister"></i>
                </div>
                <div>
                  <span>短信验证码：</span>
                  <input type='text' placeholder="请输入短信验证码" @blur="judgeInfo(CheckType.VerCode)" v-model="ver_code" class="code_box">
                  <span class="get_code" v-if='getting===false' @click="getPhoneCode()">获取验证码</span>
                  <span class="get_code count" v-if='getting'>重新发送（{{ get_time }}s）</span>
                  <i style="right: 265px" v-if="isCode"></i>
                  <em v-if="isCode&&ver_code===''">请输入验证码</em>
                  <em v-if="isCode&&ver_code!==''">请输入正确的验证码</em>
                </div>
                <div>
                  <span>新密码：</span>
                 <input type='password' @blur="judgeInfo(CheckType.Password)" @keyup="inputCheck()" placeholder="请输入新的6-20位登录密码" v-model="new_pwd">
                  <em v-if="isNew">密码应由6-20位的数字、字母或特殊符号组成</em>
                  <i v-if="isNew"></i>
                </div>
                <div v-if="resultTip">
                  <em>{{resultTip}}</em>
                </div>
                <div>
                  <span class="get_code" @click="comeTo(1)">下一步</span>
                  <span class="return_btn get_code" @click="comeTo(0)">返&nbsp;&nbsp;回</span>
                </div>
              </div>
            </div>

          </div>
          <div class="finish" v-show="menuIndex === 2">
            <div class="info_show">
              <div class="success_tip">
                <img src="../../../static/img/forget_pwd/success_icon.png">
                <p>您的新密码已修改完毕，请用新密码重新进行登录！</p>
              </div>
              <div class="btn_box">
                <span class="re_login" @click="setPop(true,false)">重新登录</span>
              </div>
            </div>
            <div class="info_show" v-if="wayIndex === 0"></div>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if='loading'></Loading>
  </div>
</template>

<script>
import SlidingValidate from '../common/SlidingValidate'
import md5 from 'js-md5'
import Loading from '../common/loading'
import throttle from 'lodash/throttle'
export default {
  data () {
    return {
      menu_list: ['找回密码', '设置新密码', '完成'],
      menuIndex: 0,
      wayIndex: 1,
      isNext: false,
      isSend: false,
      account: '',
      phone: '',
      ver_code: '',
      email: '',
      email_code: '',
      get_time: 60,
      getting: false,
      isAcc: false,
      isPhone: false,
      isCode: false,
      isEmail: false,
      isEcode: false,
      confirm_pwd: '',
      new_pwd: '',
      grade: '低',
      color_index: 1,
      isNew: false,
      isComfire: false,
      isSlide: '',
      toLink: '',
      had_phone: '',
      had_phone_tip: '',
      is_match: false,
      is_email: false,
      loading: false,
      phoneNotRegister: false,
      CheckType: {
        Account: 0,
        Phone: 1,
        Password: 2,
        VerCode: 4
      },
      resultTip: '',
      authTimetimer: null
    }
  },
  components: {
    SlidingValidate,
    Loading
  },
  created () {
    this.getPhoneCode = throttle(this.getPhoneCode, 500)
  },
  methods: {
    setPop (login, forget) {
      this.$store.dispatch('change_login_show', login)
      this.$store.dispatch('change_forget_show', forget)
      this.$store.dispatch('change_isvertifysucc', false)
      this.menuIndex = 0
      this.wayIndex = 1
      this.cleanData()
    },
    // 清空所有信息
    cleanData () {
      this.account = ''
      this.phone = ''
      this.ver_code = ''
      this.email = ''
      this.email_code = ''
      this.confirm_pwd = ''
      this.new_pwd = ''
      this.isSlide = ''
      this.had_phone = ''
      this.isAcc = false
      this.isPhone = false
      this.isCode = false
      this.isEmail = false
      this.isEcode = false
      this.isNew = false
      this.isComfire = false
      this.isNext = false
      this.isSend = false
      this.getting = false
      this.is_match = false
      this.phoneNotRegister = false
      this.resultTip = ''
      if (this.authTimetimer) {
        clearTimeout(this.authTimetimer)
      }
    },
    // 判断验证码正误
    judgeToCode (acc, code, way, tip) {
      var data = {
        account: acc,
        captcha: code,
        use: way
      }
      return this.axios.post('/api/interface/account/check_verification_code', data).then(res => {
        if (res.data.state === 0) {
          if (tip === 'phone') {
            this.isCode = false
          } else {
            this.isEcode = false
          }
          this.isNext = true
        } else {
          if (tip === 'phone') {
            this.isCode = true
          } else {
            this.isEcode = true
          }
        }
      })
    },
    // 弹窗页面跳转更换
    async comeTo (choose) {
      // 返回菜单
      if (choose === 0) {
        this.menuIndex = 0
        this.isSend = true
        this.$store.dispatch('change_isvertifysucc', false)
        this.cleanData()
        // 手机验证下一步
      } else if (choose === 1) {
        // 绑定手机号找回
        if (this.wayIndex === 1) {
          this.judgeInfo(this.CheckType.Account)
          this.judgeInfo(this.CheckType.Phone)
          this.judgeInfo(this.CheckType.VerCode)
          this.judgeInfo(this.CheckType.Password)
          if (!this.isAcc && !this.isPhone && this.account !== '' && this.phone !== '' && !this.isCode) {
            // // 校验验证码是否正确
            // this.judgeToCode(this.phone, this.ver_code, 2, 'phone')

            // this.judgeInfo(this.CheckType.VerCode)
            // this.judgeInfo(this.CheckType.Password)
            if (!this.isCode && !this.isNew && this.new_pwd !== '') {
              // 调用接口修改密码，跳转到第三屏
              this.resetPwd()
            }
          }
        } else {
          // 注册手机号找回
          this.judgeInfo(this.CheckType.Phone)
          this.judgeInfo(this.CheckType.VerCode)
          this.judgeInfo(this.CheckType.Password)

          if (!this.isPhone && !this.phoneNotRegister && !this.isCode) {
            // // 校验验证码是否正确
            // await this.judgeToCode(this.phone, this.ver_code, 5, 'phone')

            if (!this.isCode && !this.isNew && this.new_pwd !== '') {
              // 调用接口修改密码，跳转到第三屏
              this.resetPwd()
            }
          }
        }
      }
    },
    // 找回密码的步骤
    getPassword (index) {
      this.menuIndex = 1
      this.wayIndex = index
      this.cleanData()
    },
    // 判断输入信息
    judgeInfo (index) {
      const { CheckType } = this
      var accPattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
      var phPattern = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
      // 至少为字母、数字、符号两种组成，不包含空格,不能输入中文
      var pwdPattern = /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/

      this.resultTip = ''

      // 账号验证
      if (index === CheckType.Account) {
        if (this.account !== '') {
          this.isAcc = !(!accPattern.test(this.account) || !phPattern.test(this.account))
        } else {
          this.isAcc = true
        }
        // 电话验证
      } else if (index === CheckType.Phone) {
        this.isPhone = !phPattern.test(this.phone)
      } else if (index === CheckType.Password) {
        // 新密码验证
        this.isNew = !pwdPattern.test(this.new_pwd)
      } else if (index === CheckType.VerCode) {
        // 验证码验证
        this.isCode = this.ver_code === '' || this.ver_code.length !== 6
      }
    },
    // 获取验证码
    getPhoneCode () {
      // 手机号必须非空，并且合法
      if (this.phone !== '' && !this.isPhone) {
        this.resultTip = ''
        this.sendInfo(this.phone).then(res => {
          if (res.data.state === 0) {
            this.$toast('验证码已发送')
            this.get_time = 60
            this.getting = true
            this.authTimetimer = setInterval(() => {
              this.get_time--
              if (this.get_time <= 0) {
                this.getting = false
                clearInterval(this.authTimetimer)
              }
            }, 1000)
          } else {
            this.resultTip = res.data.msg
          }
        }).catch(() => {
          this.resultTip = '网络错误，请重试！'
        })
      } else {
        // 检验下账号和手机号
        // this.judgeInfo(this.CheckType.Account)
        this.judgeInfo(this.CheckType.Phone)
      }
    },
    // 判断账号是否绑定手机
    getUserData (account, type) {
      var accData = {
        account: account,
        type: type
      }
      this.axios.post('/api/interface/account/check_info_bound', accData).then(res => {
        if (res.data.state === 0) {
          if (type === 'phone') {
            this.had_phone = res.data.data.status
            this.had_phone_tip = res.data.data.phone
          }
        }
      })
    },
    // 向手机发送验证码（account：账号，type：发送类型phone/email，use：用途）
    sendInfo (account) {
      var formData = {
        account: account,
        use: 5
      }
      return this.axios.post('/api/interface/account/send_verification_code', formData)
    },
    // 新密码安全程度规则（低：纯数字，中：字母+数字，高：字母+数字+特殊符号）
    checkStrong (val) {
      var modes = 0
      if (/\d/.test(val)) modes++ // 数字
      if (/[a-z]/.test(val)) modes++ // 小写
      if (/[A-Z]/.test(val)) modes++ // 大写
      if (/\W/.test(val)) modes++ // 特殊字符
      return modes
    },
    // 验证新密码安全程度
    inputCheck () {
      if (this.new_pwd !== '') {
        var num = this.checkStrong(this.new_pwd)
        switch (num) {
          case 1:
            this.showColor(1, '低')
            break
          case 2:
            this.showColor(2, '中')
            break
          case 3:
            this.showColor(2, '中')
            break
          case 4:
            this.showColor(3, '高')
            break
          default:
            break
        }
      }
    },
    // 安全程度条颜色及等级显示设置（index：颜色条个数，grade：等级）
    showColor (index, grade) {
      this.color_index = index
      this.grade = grade
    },
    // 前往邮箱网站
    goEmail () {
      if (!this.isEmail && this.email !== '') {
        var toLink = document.getElementById('goto')
        var mail = this.email.split('@')[1]
        mail = mail.toLowerCase()
        toLink.href = 'https://mail.' + mail
      } else {
        this.isEmail = true
      }
    },
    // 重置
    resetPwd () {
      let passwordMd5 = md5(this.new_pwd)
      // 2 绑定手机号找回密码, 5 注册手机号找回密码
      const type = this.wayIndex === 1 ? 2 : 5
      const account = this.wayIndex === 1 ? this.account : this.phone
      let userData = {
        account: account,
        type: type,
        field: this.phone,
        verification_code: this.ver_code,
        new_psw: passwordMd5
      }
      this.loading = true
      this.axios.post('/api/interface/account/reset_psw', userData).then(res => {
        this.loading = false
        if (res.data.state === 0) {
          this.menuIndex = 2
          this.loading = false
        } else {
          this.resultTip = res.data.msg
        }
      }).catch(() => {
        this.loading = false
      })
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.get_back{
  .pc_forget{
    width:750px;
    background-color: #fff;
    border-radius: 5px;
    position: fixed;
    top:20%;
    left: 50%;
    margin-left: -375px;
    z-index: 15;
    .head_box{
      position: relative;
      width: 100%;
      height: 87px;
      background: url("../../../static/img/forget_pwd/head_bg.png")no-repeat;
      p{
        color: #fff;
        line-height: 87px;
        letter-spacing: 3px;
        font-size: 28px;
      }
      span{
        position: absolute;
        right: 5px;
        top:10px;
        display: block;
        width: 41px;
        height: 40px;
        cursor: pointer;
        &:hover:before {
          -webkit-transform: rotate(-135deg);
          -ms-transform: rotate(-135deg);
          transform: rotate(-135deg);
        }
        &:hover:after {
          -webkit-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          transform: rotate(-45deg);
        }

        &:hover:before, &:hover:after {
          -webkit-transition: -webkit-transform .3s ease-out;
          transition: -webkit-transform .3s ease-out;
          transition: transform .3s ease-out;
          transition: transform .3s ease-out, -webkit-transform .3s ease-out;
        }
        &:before {
          -webkit-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          transform: rotate(-45deg);
        }
        &:after {
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }
        &:before, &:after {
          position: absolute;
          top: 28px;
          right: 12px;
          content: "";
          width: 27px;
          height: 2px;
          background: #fff;
          -webkit-transition: -webkit-transform 0.5s ease-out;
          transition: -webkit-transform 0.5s ease-out;
          transition: transform 0.5s ease-out;
          transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
        }
      }
    }
    .get_detail{
      padding-top: 35px;
      .menu_box{
        width: 600px;
        margin: 0 auto;
        display: table;
        span{
          width: 33%;
          float: left;
          font-size: 22px;
          line-height: 40px;
          color: #808080;
          border-bottom: 2px solid #808080;
          &:first-child{
            margin-left: 0.5%;
          }
        }
        .menu_choose{
          color: #b60005;
          border-bottom:2px solid #b60005;
        }
      }
      .type_box{
        width: 600px;
        margin: 0 auto;
        .get_way{
          padding-bottom: 50px;
          .get_way_content {
            display: flex;
            justify-content: space-around;
            margin: 50px 0 0 0;
          }
          .way_btn{
            width: 300px;
            height: 70px;
            background: url("../../../static/img/forget_pwd/btn_bg.png") no-repeat;
            background-size: 100% 100%;
            text-align: center;
            color: #fff;
            line-height: 50px;
            margin: 10px 0 0 0;
            cursor: pointer;
          }
        }
        .information {
          padding-top: 30px;
          .step_box {
            padding-bottom: 70px;
            .slide{
              margin-bottom: 0;
            }
            div {
              position: relative;
              width: 510px;
              font-size: 16px;
              margin-bottom: 15px;
              padding-right: 90px;
              display: table;
              text-align: right;
              span {
                line-height: 43px;
                color: #4f4f4f;
              }
              .code_box{
                width: 187px;
              }
              .to_email{
                display: inline-block;
                text-decoration: underline;
                color: #b60005;
                margin-right: 270px;
                cursor: pointer;
              }
              input{
                width: 354px;
                height: 43px;
                line-height: 43px;
                background-color: #fff;
                border: 1px solid #c5c5c5;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                color: #1f2d3d;
                padding: 3px 30px 3px 10px;
                -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
                transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
                font-size: 16px;
                &:focus {
                  border-color: #d1434a;
                }
              }
              .target{
                width: 354px;
                text-align: left;
                float: right;
                span{
                  color: #ff5a00;
                  float: left;
                }
                .high_icon{
                  color: #1e8e00;
                }
                ul{
                  display: table;
                  float: left;
                  margin-top: 16px;
                  li{
                    float: left;
                    margin-left: 10px;
                    width: 70px;
                    height: 10px;
                    background: #bcbcbc;
                  }
                  .show_grade{
                    background: #ff5a00;
                  }
                  .highest{
                    background: #1e8e00;
                  }
                }
              }
              .count{
                background: #979797!important;
              }
              .get_code{
                text-align: center;
                cursor: pointer;
                display: inline-block;
                width: 157px;
                line-height: 43px;
                margin-left: 10px;
                font-size: 16px;
                color: #fff;
                letter-spacing: 1px;
                background: url("../../../static/img/forget_pwd/little_btn.jpg")no-repeat;
                border-radius: 5px;
              }
              .email_code{
                cursor: pointer;
                display: inline-block;
                width: 150px;
                height: 43px;
                margin-left: 15px;
                border:1px solid #bbb;
                text-align: center;
                color: green;
                font-weight: 600;
              }
              .return_btn{
                margin-left: 40px;
                background:#979797;
              }
              .prev_btn{
                margin-left: 40px;
              }
              .err-msg, em{
                display: block;
                width: calc(100% - 160px);
                text-align: left;
                padding-left: 160px;
                font-style: normal;
                font-size: 12px;
                color: #b50005;
                margin-top: 5px;
              }
              i{
                position: absolute;
                top: 14px;
                right: 98px;
                display: inline-block;
                width: 14px;
                height: 14px;
                background:url("../../../static/img/user_center/default_icon.png")no-repeat;
              }
            }
          }
          .second{
            div{
              margin-bottom: 5px;
              &:last-child{
                margin-top: 15px;
              }
            }
          }
        }
        .finish{
          .info_show{
            width:384px ;
            margin: 0 auto;
            padding: 55px 0 0 0;
            .success_tip{
              display: table;
              img{
                width: 62px;
                height: 61px;
                float: left;
              }
              p{
                width: 312px;
                float: left;
                margin-left: 10px;
                font-size: 18px;
                color: #4f4f4f;
                text-align: left;
                line-height: 30px;
              }
            }
            .btn_box{
              display: table;
              margin: 50px 0;
              width: 100%;
              span{
                cursor: pointer;
                display: inline-block;
                width: 193px;
                height: 58px;
                background: url("../../../static/img/forget_pwd/btn_bg.png")no-repeat;
                color: #fff;
                letter-spacing: 2px;
                line-height: 43px;
                font-size: 18px;
              }
              .re_login{
                margin: 0 auto;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/getBack/GetBackPwd.vue